export default "__VITE_PUBLIC_ASSET__e472b5d3__"